import Vue from 'vue';
import Router from 'vue-router';
import MobileFanAccountNavigation from '@js/Pages/FanAccount/MobileFanAccountNavigation';
import Profile from '@js/Pages/FanAccount/Profile';
import Security from '@js/Pages/FanAccount/Security';
import Purchases from '@js/Pages/FanAccount/Purchases';
import Settings from '@js/Pages/FanAccount/Settings';
import Following from '@js/Pages/FanAccount/Following';
import { getArenaConfig } from '@shared/utils/getArenaConfig';

// Router Plugin is used in VideoTools and Arena Vue Instance
// Regisering it twice causes an error, so we only register it on specific pages
if (window.location.pathname.startsWith('/account')) {
	Vue.use(Router);
}

const noSpoilerModeEnabled = getArenaConfig().enableNoSpoilerMode;
const followingEnabled = getArenaConfig().followingEnabled;
const isReadOnly = getArenaConfig().profileFields?.isReadOnly || false;
const disableProfileNav = getArenaConfig().disableProfileNav || false;

const blockedProfileRouteNames = ['account', 'profile', 'security', 'settings', 'purchases'];

const routes = [];

if (!disableProfileNav) {
	routes.push(
		{
			path:      '/account',
			name:      'account',
			component: MobileFanAccountNavigation,
			// will be redirected on Desktop to /account/profile
		},
		{
			path:      '/account/profile',
			name:      'profile',
			component: Profile,
			props:     true,
		},
	);

	if (!isReadOnly) {
		routes.push({
			path:      '/account/security',
			name:      'security',
			component: Security,
			props:     true,
		});
	}

	routes.push({
		path:      '/account/purchases',
		name:      'purchases',
		component: Purchases,
		props:     true,
	});

	// Settings currently only contains no spoiler mode. If we'll add more, the settings route can be added again.
	if (noSpoilerModeEnabled) {
		routes.push({
			path:      '/account/settings',
			name:      'settings',
			component: Settings,
			props:     true,
		});
	}
}

if (followingEnabled) {
	routes.push({
		path:      '/account/following',
		name:      'following',
		component: Following,
		props:     true,
	});
}

export const router = new Router({
	mode: 'history',
	routes,
});

if (disableProfileNav) {
	router.beforeEach((to, from, next) => {
		if (blockedProfileRouteNames.includes(to.name)) {
			next('/');
			return;
		}
		next();
	});
}
